<template>
  <div
    v-if="showInsuranceSurgeryDetails"
    ref="insuranceSurg"
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit desk-flex--between">
        הזן פרטי ניתוח של גורם מבטח**
        <Tags :isRequired="true" />
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>

    <div v-show="isOpen" class="book_surgery_open toggleInner">
      <div v-for="(item, i) in insuranceSurgeryTemp" :key="i">
        <div class="no_mobile surg_list_head desk-flex">
          <div class="surg_list-1">מבטח</div>
          <div class="surg_list-2">קוד ניתוח מדיקל</div>
          <div class="surg_list-3">שם/קוד ניתוח של המבטח*</div>
          <div class="surg_list-5">הערות</div>
        </div>

        <div
          class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
        >
          <!-- Insurance Type Column -->
          <div class="add_new_row flex surg_list-1">
            <div class="add_new_row_col1 desk-hide">מבטח</div>
            <div class="add_new_row_col2">
              <div class="input-opacity desk-block">
                <div class="input_area_opcity">
                  <validation-provider
                    v-if="isSpecialRhinoplasty(item)"
                    name="specialInsuranceCode"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <select2
                      dir="rtl"
                      :isSpecialInsuranceCode="i"
                      v-model="item.insurance_type"
                      @input="onSpecialInsuranceTypeChange(i, $event)"
                    >
                      <option value="">בחר</option>
                      <option value="פרטי">פרטי</option>
                      <option
                        v-if="surgery.isInsuranceCompany === 'true'"
                        value="חברת ביטוח"
                      >
                        חברת ביטוח
                      </option>
                      <option value="כללית מושלם">כללית</option>
                    </select2>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                  <textarea
                    v-else-if="isPayTypeCareService"
                    class="insurance-disabled"
                    v-model="payType"
                    placeholder="מבטח"
                    disabled
                  ></textarea>
                  <textarea
                    v-else
                    class="insurance-disabled"
                    v-model="surgery.insurance_type"
                    placeholder="מבטח"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Surgery Code Column -->
          <div class="add_new_row flex surg_list-2">
            <div class="add_new_row_col1 desk-hide">קוד ניתוח</div>
            <div class="add_new_row_col2">
              <div class="input-opacity desk-block">
                <input
                  class="english-textarea"
                  v-model="item.code_name_hospital"
                  disabled
                />
              </div>
            </div>
          </div>

          <!-- Insurance Surgery Code Selection -->
          <div class="add_new_row flex surg_list-3">
            <div class="add_new_row_col1 desk-hide">שם/קוד ניתוח*</div>
            <div class="add_new_row_col2">
              <div class="input-opacity">
                <validation-provider
                  :name="'insuranceSurgeryCode' + i"
                  :rules="
                    item.insurance_surgery_codes?.length ? 'required' : ''
                  "
                  v-slot="{ errors }"
                >
                  <multiselect
                    placeholder=""
                    v-model="item.code"
                    @search-change="onSearch($event, i)"
                    @close="onSearch('', i)"
                    :options="filteredCodes(item, i)"
                    :searchable="true"
                    :internal-search="false"
                    :allow-empty="false"
                    :options-limit="limit"
                    :disabled="
                      !item.insurance_surgery_codes?.length ||
                        item.insurance_surgery_codes?.length === 1
                    "
                  />
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>

          <!-- Notes Column -->
          <div class="add_new_row flex surg_list-5">
            <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
            <div class="input_area_opcity">
              <textarea
                v-model="item.notes"
                placeholder="פירוט..."
                autocomplete="off"
              ></textarea>
            </div>
          </div>
          <!-- Note text shown after the last item -->
          <span
            v-if="i === insuranceSurgeryTemp.length - 1"
            class="surg-side-note text--20"
          >
            לתשומת ליבך, המערכת מתאימה אוטומטית את קוד/י הקופה לקוד/י ביה"ח
            אותו/ם בחרת מעלה.
            <br />
            במידה והקוד המותאם לרשומה שגוי, יש לערוך ולבחור קוד בי"ח אחר.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/Tags.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import {
  SEARCH_OPTIONS_LIMIT,
  filterTypeheadOptions
} from "@/utilities/typehead-search.js";

export default {
  name: "InsuranceSurgeryDetails",
  components: {
    Tags,
    Multiselect
  },
  data() {
    return {
      isOpen: true,
      limit: SEARCH_OPTIONS_LIMIT,
      // Text typed in each row's typeahead, keyed by row index
      searchQueries: {}
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      insuranceSurgeryTemp: state => state.insuranceSurgeryTemp,
      insuranceForm: state => state.insuranceForm,
      isInsuranceType: state => state.isInsuranceType
    }),
    ...mapGetters("Surgery", ["isPayTypeCareService"]),

    payType() {
      return this.insuranceForm.payType;
    },

    /**
     * Determines if the insurance surgery details section should be shown
     */
    showInsuranceSurgeryDetails() {
      return (
        this.isInsuranceType &&
        (this.isPayTypeCareService ||
          this.surgery.isInsuranceCompany === "false") &&
        this.insuranceSurgeryTemp?.length
      );
    }
  },
  methods: {
    ...mapActions("Surgery", ["handleSpecialInsuranceCodeChange"]),

    onSearch(searchValue, index) {
      this.$set(this.searchQueries, index, searchValue || "");
    },

    /** Row's insurance codes matching its search, ordered by relevance */
    filteredCodes(item, index) {
      return filterTypeheadOptions(
        item.insurance_surgery_codes,
        this.searchQueries[index]
      );
    },

    /**
     * Checks if item is a special RHINOPLASTY case with כללית מושלם pay type
     */
    isSpecialRhinoplasty(item) {
      return (
        item.code_name_hospital === "1 > RHINOPLASTY" &&
        this.payType === "כללית מושלם"
      );
    },

    /**
     * Handles special insurance type change for RHINOPLASTY cases
     */
    async onSpecialInsuranceTypeChange(index, value) {
      await this.handleSpecialInsuranceCodeChange({ index, value });
    }
  }
};
</script>
